import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InputSelectInterface } from '@shared/components/form/input-select/input-select.interface';
import { BehaviorSubject } from 'rxjs';
import { FormControl, FormControlName, FormGroup, FormGroupDirective } from '@angular/forms';
import { MyErrorStateMatcher } from '@services/MyErrorStateMatcher';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-input-select-multiple',
  templateUrl: './input-select-multiple.component.html',
  styleUrls: ['./input-select-multiple.component.scss'],
})
export class InputSelectMultipleComponent implements OnInit {
  @Input() label: string;
  @Input() required = false;
  @Input() placeholder: string;
  @Input() options: InputSelectInterface[];
  @Input() class?: string;
  @Input() behaviorSubjectOptions: string;
  @Input() customNameWithId = false;
  @Input() disabledValue: BehaviorSubject<string[]>;
  @Output() handleChangeData = new EventEmitter();
  valueFormGroup?: FormGroup;
  valueFormControl?: FormControl;
  constructor(private formGroupDirective: FormGroupDirective, private formControlNameDirective: FormControlName) {}

  disable: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  matcher = new MyErrorStateMatcher();
  ngOnInit() {
    this.disabledValue.subscribe((result) => {
      this.disable.next(result);
    });
    this.valueFormGroup = this.formGroupDirective.form;
    this.valueFormControl = this.formGroupDirective.getControl(this.formControlNameDirective);
  }
  get controlName() {
    return this.formControlNameDirective.name;
  }
  get enabled() {
    return this.valueFormControl?.enabled;
  }
  get valueControl() {
    return this.valueFormControl?.value;
  }
  get isNotValidAndDirty() {
    return !this.formControlNameDirective.valid && this.formControlNameDirective.dirty;
  }
  get hasErrors() {
    return this.formControlNameDirective.errors;
  }
  handleChangeValue = (e: MatSelectChange) => {
    this.handleChangeData.emit(e.value);
  };
}
